import { useState, useEffect } from "react";
import axios from "axios";

export const DEFAULT_CONTENT = {
  heroLines: [
    { text: "Hospitality software,", accent: false },
    { text: "engineered in Nairobi.", accent: true },
    { text: "Trusted across Africa.", accent: false },
  ],
  heroSub:
    "Regional distributor of HTI Hospitality's nebula suite, Apex PMS and Plus Point POS — and the in-house studio behind HostPoint POS and HostPoint Retail, KRA eTIMS-ready systems built for African hospitality.",
  ticker: [
    "350+ venues powered",
    "12M+ guests processed yearly",
    "99.98% uptime",
    "24/7 Nairobi support desk",
  ],
  stats: [
    { value: 350, suffix: "+", label: "Hospitality venues powered", decimals: 0 },
    { value: 12, suffix: "M+", label: "Guests processed annually", decimals: 0 },
    { value: 99.98, suffix: "%", label: "Platform uptime", decimals: 2 },
    { value: 24, suffix: "/7", label: "Nairobi support desk", decimals: 0 },
  ],
  contactEmail: "info@hostechsolutions.co.ke",
  contactPhone: "+254 700 000 000",
  contactHq: "Nairobi, Kenya",
};

let cache = null;

export function useSiteContent() {
  const [content, setContent] = useState(cache || DEFAULT_CONTENT);
  useEffect(() => {
    if (cache) return;
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/content`)
      .then((r) => {
        if (r.data && r.data.key) {
          cache = { ...DEFAULT_CONTENT, ...r.data };
          setContent(cache);
        }
      })
      .catch(() => {});
  }, []);
  return content;
}
